var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DashboardBigBox"},[_c('div',{staticClass:"leftBox"},[_c('div',{staticClass:"leftTopBox"},[_c('CommandComp')],1),_c('div',{staticClass:"leftBottomBox"},[_c('LinkDetailComp')],1)]),_c('div',{staticClass:"rightBox"},[_c('router-view',{attrs:{"name":"a"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }